import type { IconName } from '@raiadrogasil/pulso-icons'
import { Icon } from '~/components/icon'
import {
  helperTextLabelErrorVariants,
  helperTextLabelVariants,
  helperTextRootVariants,
} from './helper-text.styles'

type IHelperTextProps = {
  icon?: IconName
  children: React.ReactNode
  isError?: boolean
}

export function CheckboxHelperText({
  icon,
  children,
  isError = false,
}: IHelperTextProps) {
  return (
    <div className={helperTextRootVariants()}>
      {icon && (
        <Icon
          size="tiny"
          symbol={icon}
          color={
            isError ? 'colorTextDangerAlternative' : 'colorTextNeutralDefault'
          }
        />
      )}
      <span
        className={
          isError ? helperTextLabelErrorVariants() : helperTextLabelVariants()
        }
      >
        {children}
      </span>
    </div>
  )
}
